import { render, staticRenderFns } from "./AdministrativePage.vue?vue&type=template&id=81160144"
import script from "./AdministrativePage.vue?vue&type=script&lang=js"
export * from "./AdministrativePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports